const journalPolicies = [
    {
        category: "Author’s Policy",
        points: [
            "Interested authors can submit genuine research papers to <strong>NICAS Journal of Science & Humanities</strong> but must abide by the research ethics.",
            "Authors are asked to adhere to the guidelines and paper format provided in the website to maintain the uniformity among all articles in the journal. However, any subject specific alterations can be applied on the article if needed by authors.",
            "Simultaneous submission of same paper in multiple journals and concurrent publications could be avoided.",
            "The journal and its editorial board members will not be responsible for any type of anomalities in the paper.",
            "All authors should strictly acknowledge the authorship of submitted papers in the copyright form provided by the journal. Digital signature should be avoided.",
            "Corresponding author must be clearly mentioned in the copyright form as well as the research paper, as the sole responsibility of paper lie on her / him.",
            "All communications to the journal has to be made through corresponding author only.",
            "Submitted papers will be assigned with a code and future correspondence about the paper will be made using the code.",
            "Journal follows a double-blind review process for all submitted papers. Acceptance will be notified after 15 days from the date of submission to the corresponding author.",
            "<strong>Editor’s decision about the paper will be the final one.</strong>",
            "<strong>Hard copy of the journal and certificate of publication will be individually issued to all authors of a paper. </strong>",
        ]
    },
    {
        category: "Reviewer’s Policy",
        points: [
            "Papers for review will be forwarded to mail id of respective reviewer based on area of specialization, with the author details hidden. Yet also, ensure the closeness between your area of specialization and the research paper to be reviewed so as to avoid any flaws during review process. All reviewers are requested to avoid any kind of bias and be respectful to author’s work. Review process must be completed within a stipulated time of 10 days from the date of receiving the paper. Delay in the process may be avoided. <strong>Certificate of appreciation will be provided to all reviewers.</strong>"
        ]
    },
    {
        category: "Points to Remember",
        points: [
            "Treat the author's work the way you would like your own to be treated.",
            "For an effective review to be performed, all reviewers are requested to go through author guidelines provided in the website.",
            "Be familiarized with the steps of review process.",
            "Give positive feedback first.",
            "Briefly summarize the paper’s content and findings.",
            "Number your points and refer to page and line numbers in the manuscript when making specific comments.",
            "Provide feedback on the significance, strengths and weakness of paper."
        ]
    },
    {
        category: "Peer Review Recommendations",
        points: [
            "Your recommendations should cope up with your comments.",
            "Confidential comments such as suspected plagiarism, fraud, unattributed work, unethical procedures, duplicate publication, bias, or other conflicts of interest. if any, can be forwarded to the Editor - in- Chief with a caption “ TO THE EDITOR ONLY ”.",
            "Recommendations such as (accept, reject, revise and resubmit) to be viewed openly can be indicated as follows.",
        ],
        bulletPoints: true
    },
    {
        category: "Recommending acceptance :",
        bulletPoints: false,
        points: [" Note the positive aspects of work , and also any areas that could be improved."]
    },
    {
        category: "Recommending revision :",
        bulletPoints: false,
        points: [" Intimate the specific changes you feel need to be made. If major revisions are necessary, indicate clearly what they are. The author can then reply to each point in turn."]
    },
    {
        category: "Recommending rejection :",
        bulletPoints: false,
        points: [" Provide constructive feedback describing ways by which authors could improve the research as well as to make clear the details to the editor for rejection of paper."]
    }
];

export default journalPolicies;








